// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"c2c10280","157":"0abea974","490":"289024d3","564":"8fe9fa5d","694":"fe0d1634","707":"eaf2bfd7","729":"f6c072cd","916":"1bde2a40"}[chunkId] + ".chunk.js";
};